import { Button, DrawerBody, DrawerFooter, DrawerFooterActions, SubmitButton } from "@dgs/core";
import { Form, Formik } from "formik";
import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { EventTypeSettingsFormValues } from "../shared/types/eventType";
import { useEventType } from "./EventTypeProvider";
import { EventTypeSettingsFormFields } from "./EventTypeSettingsFormFields";
import { eventTypeSettingsValidation } from "./eventTypeValidation";

const StyledForm = styled(Form)`
	display: flex;
	flex-direction: column;
	overflow: hidden;
	height: 100%;
`;

interface Props {
	onSubmitted: () => void;
	unsavedChangesPrompt: ReactNode;
	onCloseDrawer: () => void;
}

const initialValues: EventTypeSettingsFormValues = {
	eventLanguageRequirement: "optional",
	locationRequirement: "optional",
	organizerRequirement: "optional",
	addressRequirement: "optional",
	additionalInfoRequirement: "optional",
	participationPermissionRequirement: "optional",
	linkToEventRequirement: "optional",
	plannedPersonCountRequirement: "optional",
	formatRequirement: "optional",
	eventCategoryRequirement: "optional",
	industryRequirement: "optional",
	targetGroupRequirement: "optional",
	regionRequirement: "optional",
	primaryOrganizationalUnitRequirement: "optional",
	organizationalUnitRequirement: "optional",
	tagRequirement: "optional",
	preferenceRequirement: "optional",
	isHighlightRequirement: "optional",
	eventGoalRequirement: "optional",

	visitorsMetricRequirement: "prohibited",
	invitedPersonsMetricRequirement: "prohibited",
	registrationsMetricRequirement: "prohibited",
	customersMetricRequirement: "prohibited",
	employeesMetricRequirement: "prohibited",
	eventReachMetricRequirement: "prohibited",
	eventGoalRatingMetricRequirement: "prohibited",

	costCategoryRequirements: [],
	costCategories: [],
	userResponsibilities: [],
	userResponsibilityRequirements: [],
	eventGoalRatingMetricWeight: 0,
};

export const EventTypeSettingsForm: FC<Props> = ({ unsavedChangesPrompt, onSubmitted, onCloseDrawer }) => {
	const { t } = useTranslation();
	const { submitEventType, baseData, setCurrentCreateStep, settings, setSettings } = useEventType();

	const validate = eventTypeSettingsValidation(t);

	return (
		<Formik
			validate={validate}
			initialValues={settings ?? initialValues}
			onSubmit={(values) =>
				submitEventType(values, () => {
					onSubmitted();
					onCloseDrawer();
				})
			}
		>
			{(formik) => (
				<StyledForm>
					<DrawerBody>
						{unsavedChangesPrompt}
						{baseData && <EventTypeSettingsFormFields showInfo={true} />}
					</DrawerBody>
					<DrawerFooter>
						<DrawerFooterActions>
							<Button
								type="button"
								onClick={() => {
									setCurrentCreateStep("base");
									setSettings(formik.values);
								}}
							>
								{t("Back")}
							</Button>
						</DrawerFooterActions>
						<SubmitButton title={t("Save")}>{t("Save")}</SubmitButton>
					</DrawerFooter>
				</StyledForm>
			)}
		</Formik>
	);
};
